import React, { useEffect, useState } from 'react';
import useApi from '../Utils/useApi';
import useCoreApi from '../Utils/useCoreApi';
import {
  AppBar, Button, Toolbar, Typography, Container, Box,
  IconButton, Grid, Paper, Accordion, AccordionSummary, AccordionDetails, Modal, Backdrop, Fade, Tooltip
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import useCountdownToSundayMidnight from '../Utils/CountdownToSundayMidnight';
import NotificationIcon from './NotificationIcon';
import UserGreeting from './UserGreeting';
import AvatarDisplayDash from '../Avatar/AvatarDisplayDash';
import AvatarIcon from '../Avatar/AvatarIcon';
import AvatarIconLB from '../Avatar/AvatarIconLB.js'; // Ensure this path is correctconst safeApiCall = async (apiCall) => {
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { setCache, getCache } from '../Utils/cacheUtils';
import AvatarIconLBFast from '../Avatar/AvatarIconLBFast';
import { CircularProgress } from '@mui/material';
import ProfileView from './ProfileView'; // Import ProfileView
import { Tabs, Tab } from '@mui/material';



const defaultTheme = createTheme();

// Add modal styles
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw", // 80% of the viewport width
  maxWidth: "800px", // Maximum width
  height: "80vh", // 80% of the viewport height
  maxHeight: "90vh", // Maximum height
  backgroundColor: "#fff",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  padding: "16px",
  overflowY: "auto", // Add scroll for content overflow
};


const StudentDashboard = () => {
  const navigate = useNavigate();
  const [studentProgress, setStudentProgress] = useState({});
  const [lessonsProgress, setLessonsProgress] = useState([]);
  const student_id = localStorage.getItem('user_id');
  const access_token = localStorage.getItem('accessToken');
  const [currentLeague, setCurrentLeague] = useState("");
  const [leagueBadgeURL, setLeagueBadgeURL] = useState('');
  const [leaderboard, setLeaderboard] = useState([]);
  const [earnedBadges, setEarnedBadges] = useState([]);
  const [availableBadges, setAvailableBadges] = useState([]);
  const [leagueTiers, setLeagueTiers] = useState([]);
  const countdown = useCountdownToSundayMidnight();
  const api = useApi();
  const coreApi = useCoreApi();
  const [avatars, setAvatars] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [leaderboardTab, setLeaderboardTab] = useState(0); // 0 = Standard, 1 = Prestige
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  


    // Open modal and set user ID
    const handleUsernameClick = (userId) => {
      setSelectedUserId(userId);
      setIsModalOpen(true);
    };
  
    // Close modal
    const handleCloseModal = () => {
      setIsModalOpen(false);
      setSelectedUserId(null);
    };

  const getCurrentZone = (rocketfuel, thresholds) => {
    if (rocketfuel < thresholds.demotion) return 'Demotion Zone';
    if (rocketfuel > thresholds.promotion) return 'Promotion Zone';
    return 'Neutral Zone';
  };

  const thresholds = {
    promotion: 1000,
    demotion: 500
  };

  const getRowBackgroundColor = (rocketfuel) => {
    if (rocketfuel >= 1000) return 'linear-gradient(90deg, rgba(76, 175, 80, 0.3) 0%, rgba(76, 175, 80, 0.1) 100%)'; // Green gradient for promotion
    if (rocketfuel < 500) return 'linear-gradient(90deg, rgba(244, 67, 54, 0.3) 0%, rgba(244, 67, 54, 0.1) 100%)'; // Red gradient for demotion
    return 'transparent'; // Clear/white for neutral
  };

  const getZoneClassName = (rocketfuel) => {
    if (rocketfuel >= 1000) return 'promotion-zone';
    if (rocketfuel < 500) return 'demotion-zone';
    return 'neutral-zone';
  };

  const getPodiumEmoji = (position) => {
    if (position === 0) return '🥇';
    if (position === 1) return '🥈';
    if (position === 2) return '🥉';
    return null;
  };

  const getZoneIcon = (rocketfuel) => {
    if (rocketfuel >= 1000) return '↑';
    if (rocketfuel < 500) return '↓';
    return '→';
  };

  const getProgressToNextThreshold = (rocketfuel) => {
    // Always show progress toward promotion (1000 RF)
    if (rocketfuel >= 1000) {
      return 100; // Already hit promotion
    }
    return (rocketfuel / 1000) * 100; // Show progress from 0 to 1000
  };

  const currentStudentEntry = leaderboard.find(entry => entry.user_id.toString() === student_id);
  const currentRocketfuel = currentStudentEntry ? currentStudentEntry.rocketfuel : 0;
  const pointsToPromotion = thresholds.promotion - currentRocketfuel;
  const pointsToStay = thresholds.demotion - currentRocketfuel;
  const [name, setName] = useState('');

  const AvatarPlaceholder = () => (
    <Box sx={{ width: '80px', height: '80px', backgroundColor: '#f0f0f0', borderRadius: '50%' }} />
  );
  
  const BadgePlaceholder = () => (
    <Box sx={{ width: '150px', height: '150px', backgroundColor: '#f0f0f0', marginBottom: '10px' }} />
  );
  


  useEffect(() => {
    const user_id = localStorage.getItem('user_id');
    const access_token = localStorage.getItem('accessToken');
    if (user_id && access_token) {
      api.get(`/user/getname/${user_id}`, {
        headers: { 'Authorization': `Bearer ${access_token}` }
      })
      .then(response => {
        if (response.data.firstname) {
          setName(response.data.firstname);
        }
      })
      .catch(error => console.log(error));
    }
  }, []);

  const handleRowClick = (row) => {
    navigate(`/Classroom/${row.lesson_id}`);
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
  
      const safeApiCall = async (apiCall) => {
        try {
          return await apiCall;
        } catch (error) {
          console.error('API Error:', error);
          return null;
        }
      };
  
      try {
        // Step 1: Check and load cached data
        const cachedBadges = getCache('badges');
        const cachedAvailableBadges = getCache('availableBadges');
        const cachedTiers = getCache('leagueTiers');
        const cachedLeaderboard = getCache('leaderboard');
  
        if (cachedBadges) setEarnedBadges(cachedBadges);
        if (cachedAvailableBadges) setAvailableBadges(cachedAvailableBadges);
        if (cachedTiers) setLeagueTiers(cachedTiers);
        if (cachedLeaderboard) {
          setLeaderboard(cachedLeaderboard.filter(entry => entry.rocketfuel > 0));
        }
  
        // Step 2: Fetch leaderboard if not cached
        let filteredLeaderboard = cachedLeaderboard?.filter(entry => entry.rocketfuel > 0) || [];
        if (!cachedLeaderboard) {
          const leaderboardResponse = await safeApiCall(
            api.get(`/rfleague/get-hierarchical-leaderboard`, {
              headers: { Authorization: `Bearer ${access_token}` },
            })
          );
          filteredLeaderboard =
            leaderboardResponse?.data?.leaderboard?.filter(
              (entry) => entry.rocketfuel > 0
            ) || [];
          setLeaderboard(filteredLeaderboard);
          setCache('leaderboard', filteredLeaderboard, 10);
        }
  
        // Step 3: Fetch avatars now that leaderboard is ready
        const leaderboardUserIds = filteredLeaderboard.map((entry) => entry.user_id);
        const avatarResponse = await safeApiCall(
          coreApi.post(`/avatar/users`, { user_ids: leaderboardUserIds })
        );
        if (avatarResponse?.data) {
          const avatarMap = avatarResponse.data.reduce((acc, avatarData) => {
            acc[avatarData.user_id] = avatarData.components.sort(
              (a, b) => a.layer - b.layer
            );
            return acc;
          }, {});
          setAvatars(avatarMap);
        }
  
        // Step 4: Fetch remaining data in parallel
        const [
          progressResponse,
          studentProgressResponse,
          leagueResponse,
          badgesResponse,
          availableBadgesResponse,
          tiersResponse,
        ] = await Promise.all([
          safeApiCall(
            api.get(`/progress/student/${student_id}/last_completed_lessons`, {
              headers: { Authorization: `Bearer ${access_token}` },
            })
          ),
          safeApiCall(
            api.get(`/progress/student-progress/${student_id}`, {
              headers: { Authorization: `Bearer ${access_token}` },
            })
          ),
          safeApiCall(
            api.get(`/rfleague/get-current-league`, {
              headers: { Authorization: `Bearer ${access_token}` },
            })
          ),
          !cachedBadges &&
            safeApiCall(api.get(`/rfleague/get-badges`)),
          !cachedAvailableBadges &&
            safeApiCall(api.get(`/rfleague/get-available-badges`)),
          !cachedTiers &&
            safeApiCall(api.get(`/rfleague/get-league-tiers`)),
        ]);
  
        // Step 5: Update state with fetched data
        setLessonsProgress(progressResponse?.data || []);
        setStudentProgress(studentProgressResponse?.data || {});
        if (leagueResponse?.data) {
          setCurrentLeague(leagueResponse.data.league_name);
          setLeagueBadgeURL(leagueResponse.data.imgURL);
        }
  
        if (!cachedBadges) {
          setCache('badges', badgesResponse?.data?.badges || [], 10);
          setEarnedBadges(badgesResponse?.data?.badges || []);
        }
  
        if (!cachedAvailableBadges) {
          setCache('availableBadges', availableBadgesResponse?.data?.badges || [], 10);
          setAvailableBadges(availableBadgesResponse?.data?.badges || []);
        }
  
        if (!cachedTiers) {
          setCache('leagueTiers', tiersResponse?.data?.league_tiers || [], 10);
          setLeagueTiers(tiersResponse?.data?.league_tiers || []);
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchDashboardData();
  }, [student_id, access_token]);
  
  

  const handleLogin = () => {
    window.location.href = "/StudentLogin";
  };

  const anonymizeUsername = (username, userId) => {
    // If the userId matches student_id, return the username as is
    if (userId.toString() === student_id) return username;
  
    // If there's no username, return an empty string
    if (!username) return '';
  
    // Otherwise, return the full username without anonymizing
    return username;
  };

  const columns = [
    {
      field: 'position',
      headerName: '',
      width: 60,
      renderCell: (params) => {
        const podiumEmoji = getPodiumEmoji(params.api.getAllRowIds().indexOf(params.id));
        return podiumEmoji ? (
          <span style={{ fontSize: '32px' }}>{podiumEmoji}</span>
        ) : (
          <span style={{ fontSize: '16px', color: '#999' }}>#{params.api.getAllRowIds().indexOf(params.id) + 1}</span>
        );
      },
      sortable: false,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'avatar',
      headerName: '',
      width: 100,
      renderCell: (params) => {
        const userId = params.row.user_id;
        return (
          <Box sx={{ transform: 'scale(1.6)', transformOrigin: 'center' }}>
            {avatars[userId] ? (
              <AvatarIconLBFast userIds={[userId]} avatars={avatars} />
            ) : (
              <AvatarPlaceholder />
            )}
          </Box>
        );
      },
      sortable: false,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'username',
      headerName: 'Student',
      flex: 1,
      renderCell: (params) => (
        <Box
          onClick={() => handleUsernameClick(params.row.user_id)}
          sx={{
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: params.row.isStudent ? 'bold' : '600',
            color: params.row.isStudent ? '#1976d2' : '#333',
            padding: '8px 16px',
            borderRadius: '8px',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.1)',
              color: '#1976d2',
              transform: 'translateX(4px)',
            }
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: 'rocketfuel',
      headerName: 'RF',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <span style={{ fontSize: '20px' }}>{getZoneIcon(params.value)}</span>
          <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{params.value}</span>
        </Box>
      ),
    },
    {
      field: 'progress',
      headerName: 'Progress',
      width: 120,
      renderCell: (params) => {
        const progress = getProgressToNextThreshold(params.row.rocketfuel);
        const zone = getZoneClassName(params.row.rocketfuel);
        const color = zone === 'promotion-zone' ? '#4caf50' : zone === 'demotion-zone' ? '#f44336' : '#ffa726';
        return (
          <Box sx={{ width: '100%', px: 1 }}>
            <Box sx={{
              width: '100%',
              height: '8px',
              backgroundColor: '#e0e0e0',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <Box sx={{
                width: `${progress}%`,
                height: '100%',
                backgroundColor: color,
                transition: 'width 0.3s ease'
              }} />
            </Box>
          </Box>
        );
      },
      sortable: false,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'leagueBadge',
      headerName: 'Badge',
      width: 120,
      renderCell: (params) => {
        const isPrestige = params.row.prestige_level && params.row.prestige_level > 0;
        return (
          <Box sx={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
            {isPrestige && (
              <img
                src="https://cdn.jsdelivr.net/gh/tabler/tabler-icons/icons/crown.svg"
                alt="Prestige Crown"
                className="prestige-crown"
                style={{ filter: "drop-shadow(0 0 3px #ffd700)", width: 32, height: 30 }}
              />
            )}
            <LazyLoadImage
              src={params.row.imgURL || "https://fallback-url.com/placeholder.png"}
              alt="League Badge"
              effect="blur"
              className={isPrestige ? "prestige-badge" : ""}
              style={{
                width: isPrestige ? "80px" : "70px",
                height: isPrestige ? "80px" : "70px",
                transition: "all 0.2s"
              }}
            />
          </Box>
        );
      },
      sortable: false,
      align: 'center',
      headerAlign: 'center',
    },
  ];
  

  // Group and sort leaderboard by leagues
  const groupedLeaderboard = leaderboard.reduce((acc, entry) => {
    if (!acc[entry.league_name]) {
      acc[entry.league_name] = [];
    }
    acc[entry.league_name].push(entry);
    return acc;
  }, {});

  const sortedLeagues = leagueTiers
    .map(tier => tier.name)
    .filter(leagueName => groupedLeaderboard[leagueName] && groupedLeaderboard[leagueName].length > 0);

  if (!access_token) {
    return (
      <ThemeProvider theme={defaultTheme}>
        <AppBar position="relative">
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="back" onClick={() => navigate('/LessonSelect')}>
              <ArrowBackIosIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" noWrap>
              Student Dashboard
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{ bgcolor: 'background.paper', pt: 8, pb: 6 }}>
          <Container maxWidth="sm">
            <Typography variant="h5" align="center" color="text.secondary" paragraph>
              Please log in to see your dashboard
            </Typography>
            <Button variant="contained" onClick={handleLogin}>Log in</Button>
          </Container>
        </Box>
      </ThemeProvider>
    );
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  
  

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box
        sx={{
          background: 'linear-gradient(to bottom, #4a91e3, #4a91e3)', // Or any gradient you like
          minHeight: '100vh',
          width: '100%',
        }}
      >
        <AppBar
          position="static"
          color="default"
          elevation={0}
          sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
        >
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="back" onClick={() => navigate('/RLBlog')}>
              <ArrowBackIosIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" noWrap>
              {name}'s Dashboard
            </Typography>
            <Box flexGrow={1} />
            <Box sx={{ mx: 2 }}>
              <Button variant="contained" color="success" onClick={() => navigate('/Assessments')}>
                Take an Assessment
              </Button>
            </Box>
            <UserGreeting />
            <IconButton onClick={() => navigate('/Avatar')} sx={{ ml: 2 }}>
              <AvatarIcon accessToken={access_token} />
            </IconButton>
          </Toolbar>
        </AppBar>
  
        <Box sx={{ pt: 8, pb: 6 }}>
          <Container maxWidth="xl">
            <Grid container spacing={3}>
              {/* Progress and Badges */}
              <Grid item xs={12} md={4}>
                {/* Section Header */}
                <Box sx={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  padding: 3,
                  borderRadius: 2,
                  mb: 3,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  textAlign: 'center'
                }}>
                  <Typography variant="h4" fontWeight="bold">
                    📚 Your Progress
                  </Typography>
                </Box>

                {/* Progress Cards */}
                {lessonsProgress.map((progress, index) => (
                  <Paper
                    key={progress.subject_id}
                    elevation={3}
                    sx={{
                      marginBottom: 3,
                      padding: 3,
                      borderRadius: 2,
                      background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                      borderLeft: `6px solid ${['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'][index % 5]}`,
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                      }
                    }}
                  >
                    {/* Subject Name with Icon */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Box sx={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        background: `linear-gradient(135deg, ${['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'][index % 5]}, ${['#ee5a5a', '#3dbdad', '#3aa6c0', '#ff8f69', '#87c7b7'][index % 5]})`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '20px',
                        mr: 2,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                      }}>
                        {progress.subject_name.charAt(0)}
                      </Box>
                      <Typography variant="h6" fontWeight="bold" color="#333">
                        {progress.subject_name}
                      </Typography>
                    </Box>

                    {/* Last Completed */}
                    <Box sx={{
                      backgroundColor: '#f0f0f0',
                      padding: 2,
                      borderRadius: 1,
                      mb: 2
                    }}>
                      <Typography variant="caption" color="text.secondary" fontWeight="600">
                        LAST COMPLETED
                      </Typography>
                      <Typography variant="body1" fontWeight="500" color="#555">
                        {progress.last_completed_lesson_title}
                      </Typography>
                    </Box>

                    {/* Next Lesson */}
                    {progress.next_lesson_id && (
                      <Box sx={{
                        backgroundColor: '#e8f5e9',
                        padding: 2,
                        borderRadius: 1,
                        mb: 2
                      }}>
                        <Typography variant="caption" color="success.dark" fontWeight="600">
                          UP NEXT
                        </Typography>
                        <Typography variant="body1" fontWeight="500" color="#2e7d32">
                          {progress.next_lesson_title}
                        </Typography>
                      </Box>
                    )}

                    {/* Action Button */}
                    {progress.next_lesson_id && (
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={() => navigate(`/Classroom/${progress.next_lesson_id}`)}
                        sx={{
                          mt: 1,
                          py: 1.5,
                          background: `linear-gradient(135deg, ${['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'][index % 5]}, ${['#ee5a5a', '#3dbdad', '#3aa6c0', '#ff8f69', '#87c7b7'][index % 5]})`,
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '16px',
                          textTransform: 'none',
                          borderRadius: 2,
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          '&:hover': {
                            background: `linear-gradient(135deg, ${['#ee5a5a', '#3dbdad', '#3aa6c0', '#ff8f69', '#87c7b7'][index % 5]}, ${['#dd4949', '#2cac9c', '#2995af', '#ff7e58', '#76b6a6'][index % 5]})`,
                            transform: 'translateY(-2px)',
                            boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                          }
                        }}
                      >
                        Continue Learning →
                      </Button>
                    )}
                  </Paper>
                ))}
  
                {/* Standard Badges Accordion */}
                <Accordion
                  sx={{
                    mb: 2,
                    borderRadius: 2,
                    '&:before': { display: 'none' },
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ArrowBackIosIcon />}
                    sx={{
                      background: 'linear-gradient(135deg, #ffd89b 0%, #19547b 100%)',
                      color: 'white',
                      borderRadius: 2,
                      '& .MuiTypography-root': {
                        fontWeight: 'bold',
                        fontSize: '18px',
                      }
                    }}
                  >
                    <Typography>🏆 Earned Badges</Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      backgroundColor: '#fafafa',
                      padding: 3,
                    }}
                  >
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                      {availableBadges.length > 0 ? (
                        availableBadges
                          .filter(badge => badge.prestige_level === 0)
                          .map((badge) => {
                            const earned = earnedBadges.some(eBadge => eBadge.league_name === badge.league_name);
                            const badgeURL = earned ? badge.imgURL : "https://badges.ams3.cdn.digitaloceanspaces.com/nobadge.png";
                            return (
                              <div key={badge.league_name} style={{ margin: '15px 10px', textAlign: 'center' }}>
                                <LazyLoadImage
                                  src={badgeURL}
                                  alt={badge.league_name}
                                  effect="blur"
                                  style={{ width: '150px', height: '150px', marginBottom: '10px' }}
                                />
                                <Typography variant="body2">{badge.league_name}</Typography>
                              </div>
                            );
                          })
                      ) : (
                        Array.from({ length: 5 }).map((_, idx) => (
                          <BadgePlaceholder key={idx} />
                        ))
                      )}
                    </div>
                  </AccordionDetails>
                </Accordion>
  
                {/* Prestige Badges Accordion */}
                <Accordion
                  sx={{
                    borderRadius: 2,
                    '&:before': { display: 'none' },
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ArrowBackIosIcon />}
                    sx={{
                      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                      color: 'white',
                      borderRadius: 2,
                      '& .MuiTypography-root': {
                        fontWeight: 'bold',
                        fontSize: '18px',
                      }
                    }}
                  >
                    <Typography>👑 Prestige Badges</Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      backgroundColor: '#fafafa',
                      padding: 3,
                    }}
                  >
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                      {availableBadges
                        .filter(badge => badge.prestige_level > 0)
                        .map((badge) => {
                          const earned = earnedBadges.some(eBadge => eBadge.league_name === badge.league_name);
                          const badgeURL = earned
                            ? badge.imgURL
                            : "https://badges.ams3.cdn.digitaloceanspaces.com/nobadge.png";
                          return (
                            <div key={badge.league_name} style={{ margin: '15px 10px', textAlign: 'center' }}>
                              <LazyLoadImage
                                src={badgeURL}
                                alt={badge.league_name}
                                effect="blur"
                                style={{ width: '150px', height: '150px', marginBottom: '10px' }}
                              />
                              <Typography variant="body2">{badge.league_name}</Typography>
                            </div>
                          );
                        })}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </Grid>
  
              {/* Rocketfuel, League, and Leaderboard */}
              <Grid item xs={12} md={8}>
                <Paper elevation={3} style={{ padding: '16px' }}>
                  <Typography variant="h5" align="center" color="text.secondary" paragraph>
                    {currentLeague}
                  </Typography>

                  {/* League Badge with enhanced styling */}
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mb: 3
                  }}>
                    <Box sx={{
                      position: 'relative',
                      display: 'inline-block',
                      padding: 2,
                      borderRadius: '50%',
                      background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
                      boxShadow: '0 8px 16px rgba(0,0,0,0.15), inset 0 -2px 8px rgba(0,0,0,0.1)',
                    }}>
                      <LazyLoadImage
                        src={leagueBadgeURL}
                        alt="League Badge"
                        effect="blur"
                        style={{
                          width: '280px',
                          height: '280px',
                          display: 'block',
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Avatar with rounded edges and tooltip */}
                  <Tooltip title="Edit Avatar" arrow placement="top">
                    <Box
                      onClick={() => navigate('/Avatar')}
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        mb: 2,
                        '&:hover': {
                          transform: 'scale(1.05)',
                          transition: 'transform 0.2s ease',
                        }
                      }}
                    >
                      <Box sx={{
                        borderRadius: '20px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        border: '4px solid #1976d2',
                        background: 'white',
                        padding: 1,
                      }}>
                        <AvatarDisplayDash userId={student_id} accessToken={access_token} style={{ width: '300px', height: '300px', display: 'block' }} />
                      </Box>
                    </Box>
                  </Tooltip>
                  <Typography variant="h7" align="center" color="text.secondary" paragraph>
                    Make sure you've got all your rocketfuel stored before the clock strikes Midnight on Sunday!
                  </Typography>
                  <Typography variant="h6" align="center" color="text.secondary" paragraph>
                    League Update Countdown: <br /> {countdown}
                  </Typography>
                  <Typography variant="body1" align="center" color="text.secondary" paragraph>
                    This Week's Rocketfuel: <strong>{currentRocketfuel}</strong>
                  </Typography>
                  <Typography variant="body1" align="center" color="text.secondary" paragraph>
                    You are in the: <strong>{getCurrentZone(currentRocketfuel, thresholds)}</strong>
                  </Typography>
                  <Typography variant="body1" align="center" color="text.secondary" paragraph>
                    Points to stay in current league: <strong>{pointsToStay}</strong>
                  </Typography>
                  <Typography variant="body1" align="center" color="text.secondary" paragraph>
                    Points for next promotion: <strong>{pointsToPromotion}</strong>
                  </Typography>
                  <Typography variant="h6" align="center" color="text.secondary" paragraph>
                    Leaderboard
                  </Typography>
                  <Typography variant="h7" align="center" color="text.secondary" paragraph>
                    Earned RocketFuel updates every 5 minutes. Don't worry if you can't see it right away!
                  </Typography>

                  {/* Zone Legend */}
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 3,
                    my: 2,
                    p: 2,
                    backgroundColor: '#f5f5f5',
                    borderRadius: 2
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box sx={{
                        width: 30,
                        height: 30,
                        background: 'linear-gradient(90deg, rgba(76, 175, 80, 0.3) 0%, rgba(76, 175, 80, 0.1) 100%)',
                        borderRadius: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '16px'
                      }}>↑</Box>
                      <Typography variant="body2" fontWeight="bold">Promotion (≥1000 RF)</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box sx={{
                        width: 30,
                        height: 30,
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        borderRadius: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '16px'
                      }}>→</Box>
                      <Typography variant="body2" fontWeight="bold">Safe (500-999 RF)</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box sx={{
                        width: 30,
                        height: 30,
                        background: 'linear-gradient(90deg, rgba(244, 67, 54, 0.3) 0%, rgba(244, 67, 54, 0.1) 100%)',
                        borderRadius: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '16px'
                      }}>↓</Box>
                      <Typography variant="body2" fontWeight="bold">Demotion (&lt;500 RF)</Typography>
                    </Box>
                  </Box>

                  <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                    <Tabs value={tabValue} onChange={handleTabChange} centered>
                      <Tab label="Standard Leagues" />
                      <Tab label="Prestige Leagues" />
                    </Tabs>
                  </Box>
                  {tabValue === 0 && (
                    // Standard leagues tab
                    <>
                      {sortedLeagues
                        .filter(leagueName =>
                          leagueTiers.find(tier => tier.name === leagueName && (tier.prestige_level ?? 0) === 0)
                        )
                        .map(leagueName => (
                          <React.Fragment key={leagueName}>
                            <Box sx={{
                              backgroundColor: '#f5f5f5',
                              borderLeft: '6px solid #1976d2',
                              padding: 2,
                              borderRadius: 1,
                              my: 3,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                              <Typography variant="h5" fontWeight="bold" color="#1976d2">
                                {leagueName} League
                              </Typography>
                            </Box>
                            <DataGrid
                              autoHeight
                              pageSize={25}
                              rowsPerPageOptions={[10, 20, 50]}
                              disableSelectionOnClick
                              rows={groupedLeaderboard[leagueName]?.map(entry => ({
                                ...entry,
                                id: entry.user_id,
                                username: anonymizeUsername(entry.username, entry.user_id),
                                isStudent: entry.user_id.toString() === student_id,
                                imgURL: entry.imgURL,
                              })) || []}
                              columns={columns}
                              rowHeight={100}
                              sx={{
                                backgroundColor: '#fafafa',
                                borderRadius: 2,
                                padding: 1,
                                '& .MuiDataGrid-root': {
                                  backgroundColor: '#fafafa',
                                },
                                '& .MuiDataGrid-row': {
                                  minHeight: '100px !important',
                                  '&.promotion-zone': {
                                    background: 'linear-gradient(90deg, rgba(76, 175, 80, 0.3) 0%, rgba(76, 175, 80, 0.1) 100%)',
                                  },
                                  '&.demotion-zone': {
                                    background: 'linear-gradient(90deg, rgba(244, 67, 54, 0.3) 0%, rgba(244, 67, 54, 0.1) 100%)',
                                  },
                                  '&.neutral-zone': {
                                    backgroundColor: '#ffffff',
                                  },
                                  '&.highlighted-student': {
                                    border: '3px solid #1976d2',
                                    boxShadow: '0 0 15px rgba(25, 118, 210, 0.5)',
                                    fontWeight: 'bold',
                                  },
                                  '&:hover': {
                                    opacity: 0.85,
                                    transform: 'scale(1.01)',
                                    transition: 'all 0.2s ease',
                                  }
                                },
                                '& .MuiDataGrid-cell': {
                                  display: 'flex',
                                  alignItems: 'center',
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                  backgroundColor: '#e0e0e0',
                                  fontWeight: 'bold',
                                  fontSize: '16px',
                                }
                              }}
                              getRowClassName={(params) => {
                                const zoneClass = getZoneClassName(params.row.rocketfuel);
                                const studentClass = params.row.isStudent ? 'highlighted-student' : '';
                                return `${zoneClass} ${studentClass}`;
                              }}
                            />
                          </React.Fragment>
                        ))}
                    </>
                  )}
  
                  {tabValue === 1 && (
                    // Prestige leagues tab
                    <>
                      {sortedLeagues
                        .filter(leagueName =>
                          leagueTiers.find(tier => tier.name === leagueName && (tier.prestige_level ?? 0) > 0)
                        )
                        .map(leagueName => (
                          <React.Fragment key={leagueName}>
                            <Box sx={{
                              backgroundColor: '#fff8e1',
                              borderLeft: '6px solid #ffa726',
                              padding: 2,
                              borderRadius: 1,
                              my: 3,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                              <Typography variant="h5" fontWeight="bold" color="#f57c00">
                                👑 {leagueName} Prestige League
                              </Typography>
                            </Box>
                            <DataGrid
                              autoHeight
                              pageSize={25}
                              rowsPerPageOptions={[10, 20, 50]}
                              disableSelectionOnClick
                              rows={groupedLeaderboard[leagueName]?.map(entry => ({
                                ...entry,
                                id: entry.user_id,
                                username: anonymizeUsername(entry.username, entry.user_id),
                                isStudent: entry.user_id.toString() === student_id,
                                imgURL: entry.imgURL,
                              })) || []}
                              columns={columns}
                              rowHeight={100}
                              sx={{
                                backgroundColor: '#fafafa',
                                borderRadius: 2,
                                padding: 1,
                                '& .MuiDataGrid-root': {
                                  backgroundColor: '#fafafa',
                                },
                                '& .MuiDataGrid-row': {
                                  minHeight: '100px !important',
                                  '&.promotion-zone': {
                                    background: 'linear-gradient(90deg, rgba(76, 175, 80, 0.3) 0%, rgba(76, 175, 80, 0.1) 100%)',
                                  },
                                  '&.demotion-zone': {
                                    background: 'linear-gradient(90deg, rgba(244, 67, 54, 0.3) 0%, rgba(244, 67, 54, 0.1) 100%)',
                                  },
                                  '&.neutral-zone': {
                                    backgroundColor: '#ffffff',
                                  },
                                  '&.highlighted-student': {
                                    border: '3px solid #1976d2',
                                    boxShadow: '0 0 15px rgba(25, 118, 210, 0.5)',
                                    fontWeight: 'bold',
                                  },
                                  '&:hover': {
                                    opacity: 0.85,
                                    transform: 'scale(1.01)',
                                    transition: 'all 0.2s ease',
                                  }
                                },
                                '& .MuiDataGrid-cell': {
                                  display: 'flex',
                                  alignItems: 'center',
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                  backgroundColor: '#e0e0e0',
                                  fontWeight: 'bold',
                                  fontSize: '16px',
                                }
                              }}
                              getRowClassName={(params) => {
                                const zoneClass = getZoneClassName(params.row.rocketfuel);
                                const studentClass = params.row.isStudent ? 'highlighted-student' : '';
                                return `${zoneClass} ${studentClass}`;
                              }}
                            />
                          </React.Fragment>
                        ))}
                    </>
                  )}
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>
  
        {/* Modal for ProfileView */}
        <Modal
          open={isModalOpen}
          onClose={handleCloseModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={isModalOpen}>
            <div style={modalStyle}>
              {selectedUserId && <ProfileView userId={selectedUserId} />}
            </div>
          </Fade>
        </Modal>
      </Box>
    </ThemeProvider>
  )
}
export default StudentDashboard;
